import { useState, useEffect } from 'react'
import { useQuery } from "@apollo/client/react";
import { useParams, useNavigate } from 'react-router'
import { GET_ZILLOW } from '@/housefolios-components/TitleButtons/AddPropertyButton/queries'
import { GET_COMPPROPERTIES } from '@/housefolios-components/PropertyContainer/queries'
import { map, head, sum } from '@/utils/lodash'

/**
 * Custom hook for public property page data and state management
 */
export const usePublicProperty = () => {
  const { view = 'Summary' } = useParams()
  const navigate = useNavigate()
  const [isSidebarMenuOpen, setIsSidebarMenuOpen] = useState(false)
  const [openSignup, setOpenSignup] = useState(false)
  const [anchorElMoreOptionsMenu, setAnchorElMoreOptionsMenu] =
    useState(null)

  const urlParams = new URLSearchParams(window.location.search)

  // Mock data for now - replace with actual query when ready
  const getZillowPropertyData = {
    zpid: 0,
    address: '123 Fake St.',
    city: 'Townsville',
    state: 'ZZ',
    zip: '55555',
    beds: 4,
    baths: 3,
    sqft: 5000,
    year: 1993,
    location: {
      latitude: 35,
      longitude: -80,
    },
    files: {
      url: [],
    },
    zestimate: {
      amount: [{ _: 10000 }],
    },
    rentZestimate: {
      amount: [{ _: 333 }],
    },
    taxAssessment: 500,
    description: 'Hardcoded test property.',
  }

  // Process property data
  let property = getZillowPropertyData
  property.acquisition = {
    analysis: {
      listPrice: property.zestimate?.amount[0]._ || null,
      rent: property.rentZestimate?.amount[0]._ || null,
    },
  }
  property.images = []
  if (getZillowPropertyData.files) {
    map(getZillowPropertyData.files.url, (url) => {
      property.images.push({ url: url  })
    })
  }

  // Get comp properties
  const { data: compData, loading: compLoading } = useQuery(
    GET_COMPPROPERTIES,
    {
      variables: { propertyId: property?._id },
      skip: !property?._id,
    },
  )

  const compProperties = compData?.compProperties || []
  const compValues = map(compProperties, (comp) => ({
    propertyPrice: Number(
      comp.estval * (1 + comp.priceAdjustment / 100),
    ),
    propertyPerSqft: comp.sqft
      ? Number(comp.estval * (1 + comp.priceAdjustment / 100)) /
          comp.sqft || null
      : null,
    sqft: comp.sqft,
  }))

  // Event handlers
  const toggleSidebarMenu = () =>
    setIsSidebarMenuOpen(!isSidebarMenuOpen)
  const toggleSignup = () => setOpenSignup(!openSignup)
  const handleClickMoreOptionsMenu = (event) => {
    setAnchorElMoreOptionsMenu(event.currentTarget)
  }
  const handleCloseMoreOptionsMenu = () => {
    setAnchorElMoreOptionsMenu(null)
  }

  const toggle = (tab) => {
    if (
      tab !== 'Summary' &&
      tab !== 'Comps' &&
      tab !== 'MarketAnalysis'
    ) {
      setOpenSignup(true)
    } else if (view !== tab) {
      navigate(
        `/publicproperty/${tab}?address=${urlParams.get('address')}&city=${urlParams.get('city')}&state=${urlParams.get('state')}&zip=${urlParams.get('zip')}`,
      )
    }
  }

  return {
    // Data
    property,
    compProperties,
    compValues,
    activeTab: view,

    // State
    isSidebarMenuOpen,
    openSignup,
    anchorElMoreOptionsMenu,

    // Loading states
    loading: compLoading,

    // Event handlers
    toggleSidebarMenu,
    toggleSignup,
    handleClickMoreOptionsMenu,
    handleCloseMoreOptionsMenu,
    toggle,
  }
}
